import { Rating } from 'client/CommonComponents';
import './RatingInfo.scss'

const ratingContent =[
    {
        ratingValue: 1,
        value:'Poor (1)',
        text:'Severe mechanical and/or cosmetic defects; Problems that can not be readily fixed, such as damaged or bent frame, or body rusted-through; Needs Replaced / Immediate Disposal.'
    },
    {
        ratingValue: 2,
        value:'Fair (2)',
        text:'Some mechanical or cosmetic defects, dings or scratches; Still in reasonable running condition; There is normal, repairable rust damage; Tires may need replaced; Should be disposed of in next calendar year.'
    },
    {
        ratingValue: 3,
        value:'Good (3)',
        text:'Free of any major defects. Paint body and interior have only minor blemishes(if any dings or scratches); No major mechanical problems; Little to no rust; Tires match and have substantial tread remaining.'
    },
    {
        ratingValue: 4,
        value:'Very Good (4)',
        text:'Excellent mechanical condition; Paint and body work is rust free; Engine compartment is clean with no fluid leaks. Free of any wear or visible defects; All tires match.'
    },
    {
        ratingValue: 5,
        value:'New / Excellent (5)',
        text:'Still under warranty; Near perfect condition both cosmetically and mechanically; All tires match (including spare if present).'
    }
]

const assetStatusContent = [
    {
        ratingValue: "InOperable",
        value:'Inoperable (mechanical failure):',
        text:' Vehicle will not start/run or drive.  Unrepaired.  Such as mechanical or transmission failure.'
    },
    {
        ratingValue: "Wrecked",
        value:'Wrecked (significant Body Damage):',
        text:'Severely damaged, wrecked.'
    },
    {
        ratingValue: 'Operable',
        value:'Operable (running normally):',
        text:'Normal wear/tear, body dents and scrapes, (if flat tires- death batteries) tow needed, vehicle starts/runs and drives.'
    },
]
const RatingInfo =(props:any)=>{
    const {
        isOverAllCondition
    } = props
    let hoveringContentTemp = isOverAllCondition ? ratingContent : assetStatusContent
    return(
        <div className='Rating-Info-Container'>
            <p className='heading-text'>{isOverAllCondition ? 'Condition Choices and Their Meanings' : 'Asset Status Choices and Their Meanings'}</p> 
            {
            hoveringContentTemp.map((item:any, _index:any)=>{
                return(
                    <>
                    { 
                        props?.RatingValue == item.ratingValue ? <div className='Rating-Info'>
                            <div>
                                {isOverAllCondition ? 
                                <Rating defaultRating={item.ratingValue} className='rating-icons' readOnly={true} data-attribute="RatingInfo_Default_Rating" />
                                : null }
                                <span className='text-bold'>{item.value}</span>
                            </div>                        
                            <p className='rating-description'>{item.text}</p>
                        </div> : null
                    }     
                    </>
                )
            })       
            }        
        </div>
    )
}

export default RatingInfo;